import ToolShell, { OutputBlock } from "@/pages/tools/ToolShell";

export default function GearPromo() {
  return (
    <ToolShell
      testid="tool-gear-page" eyebrow="Pro Tool" toolKey="gear" title="Gear Promo Builder"
      subtitle="Launch pack for a piece of gear - caption, reel, carousel, ads, email."
      endpoint="/tools/gear-promo" tier="pro" transformPayload={(s) => ({ brief: s })}
      fields={[
        { key: "product", label: "Product name", type: "text", required: true, placeholder: "e.g. Cressi Frog Plus open-heel fins" },
        { key: "product_url", label: "Product page URL (optional)", type: "text", placeholder: "https://your-shop.com/products/frog-plus", help: "If provided, we'll read the page and pull real details into the output." },
        { key: "price", label: "Price (EUR)", type: "text" },
        { key: "key_features", label: "Key features", type: "textarea", rows: 4, placeholder: "Bullet a few features and what they enable" },
        { key: "ideal_user", label: "Ideal user", type: "text", placeholder: "e.g. Recreational divers in tropical to temperate water" },
      ]}
      renderOutput={(o) => (
        <>
          <OutputBlock label="USP">{o.unique_selling_proposition}</OutputBlock>
          {o.feature_to_benefit_table && (
            <OutputBlock label="Feature → Benefit">
              <table className="w-full text-[14.5px]">
                <thead><tr className="text-left text-[11px] tracking-[0.2em] uppercase font-bold text-[#64748B]"><th className="py-2">Feature</th><th className="py-2">Benefit</th></tr></thead>
                <tbody>{o.feature_to_benefit_table.map((r, i) => <tr key={i} className="border-t border-[#E2E8F0]"><td className="py-2">{r.feature}</td><td className="py-2 text-[#475569]">{r.benefit}</td></tr>)}</tbody>
              </table>
            </OutputBlock>
          )}
          <OutputBlock label={`Instagram caption (${(o.instagram_caption || "").length} chars)`} copyValue={o.instagram_caption}>
            <div className="whitespace-pre-wrap leading-relaxed">{o.instagram_caption}</div>
          </OutputBlock>
          {o.reel_concept && (
            <OutputBlock label="Reel concept">
              <div className="space-y-2 text-[14.5px]">
                <div><span className="dms-label">Archetype</span><div>{o.reel_concept.hook_archetype}</div></div>
                <div><span className="dms-label">Hooks</span><ul className="mt-1 list-disc pl-5">{(o.reel_concept.hooks || []).map((h, i) => <li key={i}>&ldquo;{h}&rdquo;</li>)}</ul></div>
                <div><span className="dms-label">Structure</span><div>{o.reel_concept.structure}</div></div>
                <div><span className="dms-label">CTA</span><div>{o.reel_concept.cta}</div></div>
              </div>
            </OutputBlock>
          )}
          {o.carousel_outline && <OutputBlock label="Carousel outline"><ol className="list-decimal pl-5 space-y-1">{o.carousel_outline.map((s, i) => <li key={i}>{s}</li>)}</ol></OutputBlock>}
          {o.email_promo && (
            <OutputBlock label="Email promo">
              <div className="space-y-2"><div><span className="dms-label">Subject</span><div className="font-semibold">{o.email_promo.subject}</div></div><div><span className="dms-label">Body</span><div className="whitespace-pre-wrap leading-relaxed mt-1">{o.email_promo.body}</div></div><div><span className="dms-label">CTA</span><div>{o.email_promo.cta}</div></div></div>
            </OutputBlock>
          )}
          {o.meta_ad_variants && (o.meta_ad_variants).map((a, i) => (
            <OutputBlock key={i} label={`Meta ad variant ${a.variant}`}>
              <div className="space-y-1.5"><div><span className="dms-label">Primary text</span><div>{a.primary_text}</div></div><div><span className="dms-label">Headline</span><div className="font-semibold">{a.headline}</div></div><div><span className="dms-label">Description</span><div>{a.description}</div></div></div>
            </OutputBlock>
          ))}
          {o.objection_responses && (
            <OutputBlock label="Objection responses">
              <div className="space-y-3">{o.objection_responses.map((r, i) => (<div key={i}><div className="font-semibold text-[#0A2342]">{r.objection}</div><div className="text-[#475569] mt-1">{r.response}</div></div>))}</div>
            </OutputBlock>
          )}
          {o.use_case_scenarios && <OutputBlock label="Use cases"><ul className="list-disc pl-5 space-y-1">{o.use_case_scenarios.map((u, i) => <li key={i}>{u}</li>)}</ul></OutputBlock>}
        </>
      )}
    />
  );
}
